import type {PinListItem} from './types';

import {Button, Loading} from '@ds/components';
import {PageLayout} from '@ds/layout';
import historyEmptyState from 'assets/images/promotion-center/new/historyEmptyState.svg';
import Empty from 'common/empty/Empty';
import {useEffect} from 'react';
import {useNavigate} from 'react-router-dom';
import {useAppDispatch, useAppSelector} from 'store';
import {getPinRegions, getPins} from 'store/slices/pin/thunk';

import {PIN_ROUTES} from '../constants';
import {getPinVendorId} from '../utils';
import PinHistoryList from './components/PinHistoryList/PinHistoryList';

const PinList: React.FC = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const vendorId = getPinVendorId();
  const {pins, loading, pinRegions} = useAppSelector((state) => state.pin);
  const pinItems = (pins ?? []) as PinListItem[];

  useEffect(() => {
    void dispatch(getPins({vendor_id: vendorId}));
    void dispatch(getPinRegions({vendor_id: vendorId}));
  }, [dispatch, vendorId]);

  return (
    <PageLayout
      contentId="pin-list"
      footer={
        pinRegions?.length ? (
          <Button fullWidth onClick={() => navigate(PIN_ROUTES.buyPackage)}>
            خرید بسته
          </Button>
        ) : undefined
      }
    >
      {loading ? (
        <div className="flex min-h-60 flex-1 items-center justify-center">
          <Loading size="large" color="primary" />
        </div>
      ) : pinItems.length > 0 ? (
        <PinHistoryList pins={pinItems} />
      ) : (
        <Empty illustration={historyEmptyState} className="min-h-60 flex-1 gap-1 px-4 text-center">
          <p className="text-body-sm-emphasis text-neutral-fg">خریدی برای نمایش وجود ندارد</p>
          <p className="text-body-sm text-gray-07">تا به حال هیچ جایگاهی نخریده‌اید!</p>
        </Empty>
      )}
    </PageLayout>
  );
};

export default PinList;
